/**
 * Internal dependencies
 */
import { PREFIX_EVENTS_PRO_STORE } from '@moderntribe/events-pro/data/prefix';

export const SET_ADDITIONAL_FIELD_INITIAL_STATE = `${ PREFIX_EVENTS_PRO_STORE }/SET_ADDITIONAL_FIELD_INITIAL_STATE`;
export const ADD_ADDITIONAL_FIELD = `${ PREFIX_EVENTS_PRO_STORE }/ADD_ADDITIONAL_FIELD`;
export const REMOVE_ADDITIONAL_FIELD = `${ PREFIX_EVENTS_PRO_STORE }/REMOVE_ADDITIONAL_FIELD`;

export const SET_ADDITIONAL_FIELD_LABEL = `${ PREFIX_EVENTS_PRO_STORE }/SET_ADDITIONAL_FIELD_LABEL`;
export const SET_ADDITIONAL_FIELD_IS_PRISTINE = `${ PREFIX_EVENTS_PRO_STORE }/SET_ADDITIONAL_FIELD_IS_PRISTINE`;
export const SET_ADDITIONAL_FIELD_VALUE = `${ PREFIX_EVENTS_PRO_STORE }/SET_ADDITIONAL_FIELD_VALUE`;
export const SET_ADDITIONAL_FIELD_TYPE = `${ PREFIX_EVENTS_PRO_STORE }/SET_ADDITIONAL_FIELD_TYPE`;
export const SET_ADDITIONAL_FIELD_OPTIONS = `${ PREFIX_EVENTS_PRO_STORE }/SET_ADDITIONAL_FIELD_OPTIONS`;
export const SET_ADDITIONAL_FIELD_DIVIDER_LIST = `${ PREFIX_EVENTS_PRO_STORE }/SET_ADDITIONAL_FIELD_DIVIDER_LIST`;
export const SET_ADDITIONAL_FIELD_DIVIDER_END = `${ PREFIX_EVENTS_PRO_STORE }/SET_ADDITIONAL_FIELD_DIVIDER_END`;
export const APPEND_ADDITIONAL_FIELD_VALUE = `${ PREFIX_EVENTS_PRO_STORE }/APPEND_ADDITIONAL_FIELD_VALUE`;
export const REMOVE_ADDITIONAL_FIELD_VALUE = `${ PREFIX_EVENTS_PRO_STORE }/REMOVE_ADDITIONAL_FIELD_VALUE`;
export const SET_ADDITIONAL_FIELD_CHANGE = `${ PREFIX_EVENTS_PRO_STORE }/SET_ADDITIONAL_FIELD_CHANGE`;
export const SET_ADDITIONAL_FIELD_META_KEY = `${ PREFIX_EVENTS_PRO_STORE }/SET_ADDITIONAL_FIELD_META_KEY`;
export const SET_ADDITIONAL_FIELD_OUTPUT = `${ PREFIX_EVENTS_PRO_STORE }/SET_ADDITIONAL_FIELD_OUTPUT`;
export const SET_ADDITIONAL_FIELD_BLUR = `${ PREFIX_EVENTS_PRO_STORE }/SET_ADDITIONAL_FIELD_BLUR`;
